import merge from 'lodash/merge';
import authResolvers from './auth';
import companyResolvers from './company';
import userResolvers from './user';

export default merge(authResolvers, companyResolvers, userResolvers);
